import { STEP_STORAGE_KEYS } from "../constants/storageConstants";
import { ALLOWED_DAY_TYPES } from "../constants/timeConstants";

/**
 * @param {object} projectData data for the whole project
 * @returns undefined if the user has not chosen an analysis type yet,
 * otherwise returns "RAMP_TERMINAL_INTERSECTION" or "AT_GRADE_INTERSECTION"
 */
export const getAnalysisType = (projectData) =>
  projectData?.[STEP_STORAGE_KEYS.GLOBAL_INPUT_DATA]?.analysisType;

/**
 * @param {object} projectData data for the whole project
 * @returns undefined if the user has not chosen an evaluation type yet,
 * otherwise returns "CAP_X" or "LIFE_CYCLE_COST"
 */
export const getEvaluationType = (projectData) =>
  projectData?.[STEP_STORAGE_KEYS.PROJECT_INFORMATION]?.evaluationType;

export const getIsWeekendAnalysis = (projectData) =>
  projectData?.[STEP_STORAGE_KEYS.GLOBAL_INPUT_DATA]?.allowedDayTypes ===
  ALLOWED_DAY_TYPES.WEEKDAY_AND_WEEKEND;
